import {Directive, ElementRef, HostListener, Input, NgZone, OnDestroy, OnInit} from '@angular/core';

@Directive({
  selector: '[appAutoResizeInput]',
  standalone: true
})
export class AutoResizeInputDirective implements OnInit, OnDestroy {
  @Input() defaultHeight = 'auto';
  private resizeObserver?: ResizeObserver;
  private lastHeight = '';
  private _trigger: any;

  @Input('appAutoResizeInput')
  set trigger(value: any) {
    if (this._trigger !== value) {
      this._trigger = value;
      setTimeout(() => this.resize(), 0);
    }
  }

  constructor(private el: ElementRef, private ngZone: NgZone) {
    setTimeout(() => {
      this.resize();
    }, 300);
  }

  @HostListener('input')
  onInput() {
    this.resize();
  }

  @HostListener('paste')
  onPaste() {
    setTimeout(() => this.resize(), 0);
  }

  @HostListener('keydown')
  onKeydown() {
    setTimeout(() => this.resize(), 0);
  }

  @HostListener('focus')
  onFocus() {
    this.resize();
  }

  ngOnInit() {
    this.resize();

    if (typeof ResizeObserver !== 'undefined') {
      this.ngZone.runOutsideAngular(() => {
        this.resizeObserver = new ResizeObserver(() => {
          // Skip if the current height matches what we last computed
          // This breaks the infinite loop: resize() → style.height change → ResizeObserver → resize()
          if (this.el.nativeElement.style.height === this.lastHeight) {
            return;
          }
          this.resize();
        });
        this.resizeObserver.observe(this.el.nativeElement);
      });
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  resize() {
    const textarea = this.el.nativeElement;

    if (!textarea) return;

    const scrollTop = textarea.scrollTop;
    const parsed = parseInt(this.defaultHeight);
    const resetHeight = !isNaN(parsed) ? parsed + 'px' : this.defaultHeight;

    // Temporarily collapse to measure true content height
    textarea.style.height = resetHeight;
    textarea.offsetHeight;

    const newHeight = Math.max(textarea.scrollHeight, parsed || 20) + 'px';

    // Always restore to computed height (we collapsed it above)
    textarea.style.height = newHeight;
    textarea.scrollTop = scrollTop;

    // Track last height so ResizeObserver callback can bail out early
    this.lastHeight = newHeight;
  }
}
